import type {
  AiConsultantDisplayMessageType,
  AiConsultantMessageRole,
} from '@freelancer/datastore/collections';
import type { TrackingExtraParams } from '@freelancer/tracking/interface';

export interface AiConsultantMessageValid {
  readonly type:
    | AiConsultantDisplayMessageType.CHAT
    | AiConsultantDisplayMessageType.ERROR
    | AiConsultantDisplayMessageType.LIMIT;
  readonly role: AiConsultantMessageRole;
  readonly content: string;
}

export interface AiConsultantMessageLoading {
  readonly type: AiConsultantDisplayMessageType.LOADING;
  readonly role: AiConsultantMessageRole;
}

export interface AiConsultantMessageDraftProject {
  readonly type: AiConsultantDisplayMessageType.DRAFT_PROJECT;
  readonly role: AiConsultantMessageRole;
  readonly content: string;
  readonly title: string;
  readonly description: string;
}

export interface AiConsultantProjectData {
  readonly trimmedContent: string; // assistant reply without the data
  readonly title: string;
  readonly description: string;
}

export type AiConsultantTrackingExtraParams = Partial<
  Pick<TrackingExtraParams, 'message' | 'response'>
>;

export enum SaveConversationToastError {
  GENERIC_ERROR = 'generic-error',
  SHORT_HISTORY_ERROR = 'short-history-error',
  RATE_LIMIT_ERROR = 'rate-limit-error',
}
